export default __webpack_public_path__ + "static/img/exhib-01.bd4577e.png";